import { useTranslation } from 'react-i18next';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { coinIcons } from 'shared/constants';
import { genericFormatBet } from 'shared/utils/betFormater';
import { CurrencyType } from 'shared/web3';

import Heart from 'assets/png/heart-filled.png?format=webp;avif&as=picture';
import long from 'assets/png/quick-game/long.png?format=webp;avif&as=picture';
import medium from 'assets/png/quick-game/medium.png?format=webp;avif&as=picture';
import short from 'assets/png/quick-game/short.png?format=webp;avif&as=picture';
import QuickGameIcon from 'assets/svg/components/arrow-quick.svg?react';
import Loader from 'assets/svg/loader.svg?react';

import { useQuickGame } from './use-quick-game';

interface ILiveGameItemProps {
  wins?: number;
  currency: CurrencyType;
  amount: number;
  startGameHandler: (bet: number, wins: number, playerB: string) => void;
}

export const QuickGameItemMobile = ({
  wins,
  currency,
  amount,
  startGameHandler,
}: ILiveGameItemProps) => {
  const { t } = useTranslation();

  const { createGameHandler, gameType, isLoading, normalizedAmount } = useQuickGame({
    amount,
    currency,
    wins,
    startGameHandler,
  });

  return (
    <div className="w-full">
      <div
        className={`grid grid-cols-[2fr_1fr_1fr_1.5fr] rounded-lg border border-dashed border-[#FFA700] bg-gradient-to-r from-[#0D1450] to-[#151552] p-0.5 pr-2 transition-all sm:rounded-2xl`}
      >
        <div className="items flex items-center gap-1">
          <OptimizedImage
            imageData={wins === 3 ? short : wins === 6 ? medium : long}
            alt="short"
            className="h-7 w-7"
          />
          <div className="flex flex-col">
            <span className="font-chivo text-[8px] font-medium leading-3 text-yellow">
              {t('quickGame.vsRandoms')}
            </span>
            <span className="text-[8px] font-medium leading-[10px] text-white opacity-75">
              {t(gameType)}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-center gap-1">
          {currency?.symbol ? (
            <img
              src={coinIcons[currency.symbol as keyof typeof coinIcons]}
              alt="coin"
              className="h-[18px] w-[18px]"
            />
          ) : null}
          <div>
            <p className="text-[10px] font-semibold leading-[10px] text-white">
              {genericFormatBet(
                normalizedAmount.toString(),
                'text-[10px] sm:text-[12px] mb-2 px-0.5',
              )}
            </p>

            <p className="text-[10px] font-semibold text-white opacity-75">{currency?.symbol}</p>
          </div>
        </div>

        <div className="relative flex items-center justify-center">
          <p className="mr-0.5 text-md font-semibold text-white">{wins}</p>
          <OptimizedImage imageData={Heart} alt="heart" className="h-4 w-4" />
        </div>

        <div className="flex items-center justify-end">
          <button
            className={`justify- flex items-center gap-0.5 text-sm font-extrabold uppercase`}
            onClick={createGameHandler}
          >
            {' '}
            {isLoading ? (
              <Loader
                data-testid="loader"
                className="h-4 w-4 animate-spin fill-[#fff] text-[#FFC000] sm:h-8 sm:w-8"
              />
            ) : (
              <>
                <QuickGameIcon className="h-6 w-6 text-[#FFF874]" />
                <span className="w-[34px] leading-none text-[#FFF874]">
                  {t('quickGame.quickGame')}
                </span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
